// extracted by mini-css-extract-plugin
module.exports = {"root":"ProductImage_root__YsZpz"};